import { Button } from 'components/Button';
import styled from 'styled-components';
import { medias } from 'assets/styled/tokens';
export const MenuContainer = styled.div`
  display: none;
  @media (min-width: ${medias.desktopSm}) {
    height: 30%;
    width: 575px;
    color: #ffffff;
    font-family: Blinker;

    font-weight: 700;
    line-height: 16px;
    letter-spacing: 0.5px;
    display: flex;
    gap: 24px;
  }
`;

export const MenuButton = styled(Button)`
  border: none;
  height: 32px;
  display: flex;
  font-size: 20px;
  justify-content: center;
  align-items: center;
  text-transform: capitalize;
  background-color: #1e1e1e;
  width: ${props => props.Width};
  padding: 0px;
  :first-of-type {
    padding-left: 0;
    justify-content: flex-start;
  }
`;
